import React, { RefObject, createRef, useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { Props } from './interfaces';
import './DescriptionBlock.scss';
import './DescriptionBlock-media.scss';
import {content} from "../../services/content";

const DescriptionBlock = ({ title, text, bg = false, widthWindow, open = false }: Props) => {
  const [showAllDescription, setShowAllDescription] = useState(false);
  const handlerShowAllDescription = () => {
    setShowAllDescription(true);
    setHeightText(fullHeightText);
    textRef.current?.classList.remove('description__text_hide');
  };

  const [heightText, setHeightText] = useState('auto');
  const [fullHeightText, setFullHeightText] = useState('auto');

  const textRef: RefObject<HTMLDivElement> = createRef();

  useEffect(() => {
    const height = textRef.current?.offsetHeight;
    setFullHeightText(`${height}px`);

    const heightDevice = widthWindow > 720 ? 4 * 24 : 10 * 24;

    if (height && height > heightDevice) {
      widthWindow > 720 && widthWindow < 1440
        ? setHeightText(`${heightDevice / 14.4}vw`)
        : setHeightText(`${heightDevice}px`);
    } else {
      setHeightText(`auto`);
      setShowAllDescription(true);
    }

    if (open) {
      handlerShowAllDescription();
    }
  }, []);

  return (
    <div className={`description${bg ? ' description_bg' : ''}`}>
      {title ? <h3 className="description__title" dangerouslySetInnerHTML={{ __html: title }}></h3> : null}
      <p
        ref={textRef}
        className={`body2 description__text${!showAllDescription ? ' description__text_hide' : ''}`}
        dangerouslySetInnerHTML={{ __html: text }}
        style={{ height: heightText }}
      ></p>
      {!showAllDescription ? (
        <p className="body2 description__show-all" onClick={handlerShowAllDescription}>
          {content.descriptionBlock.showMore}
        </p>
      ) : null}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(DescriptionBlock));
